import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
    values: {
      caret_down: "mdi-menu-down",
      send: "mdi-send",
      emoji: "mdi-emoticon-outline",
      chevron_left: "mdi-chevron-left",
      chevron_right: "mdi-chevron-right",
      warning: "mdi-alert",
      check_circle: "mdi-check-circle",
      cancel: "mdi-close-circle",
      play_circle: "mdi-play-circle",
      chevron_double_up: "mdi-chevron-double-up",
      search: "mdi-magnify",
      dots_vertical: "mdi-dots-vertical",
      plus_circle: "mdi-plus-circle-outline",
      delete: "mdi-delete",
      download: "mdi-download",
      arrow_right: "mdi-arrow-right",
      gift: "mdi-gift-outline",
      facebook: "mdi-facebook",
      twitter: "mdi-twitter",
      instagram: "mdi-instagram",
      linkedin: "mdi-linkedin",
    },
  },
  theme: {
    themes: {
      light: {
        primary: "#E8000B",
        success: "#00924e",
        error: "#a90009",
      },
    },
  },
});
